import { CheckCircle, Info, WarningCircle } from '@phosphor-icons/react';
import { useIslandState } from '../IslandProvider';
import { FARBE, getoent } from '../pille-stil';

const TON = {
  info: { Icon: Info, farbe: FARBE.blau },
  success: { Icon: CheckCircle, farbe: FARBE.gruen },
  error: { Icon: WarningCircle, farbe: FARBE.rotHell },
} as const;

/** Meldung (Handoff Pille §3): runde Icon-Plakette nach Ton, Titel, optional Text. */
export function ToastContent() {
  const { toast } = useIslandState();
  if (!toast) return null;
  const { Icon, farbe } = TON[toast.tone] ?? TON.info;
  return (
    <div role="status" aria-live="polite" className="flex h-full items-center" style={{ gap: 12, padding: '0 14px 0 10px' }}>
      <span className="flex shrink-0 items-center justify-center rounded-full" style={{ width: 40, height: 40, background: getoent(farbe, 0.18) }}>
        <Icon size={20} weight="fill" color={farbe} />
      </span>
      <span className="flex min-w-0 flex-1 flex-col">
        <span className="truncate" style={{ fontSize: 13, fontWeight: 800 }}>{toast.title}</span>
        {toast.body && <span className="truncate" style={{ fontSize: 12, color: 'rgba(255,255,255,0.62)' }}>{toast.body}</span>}
      </span>
    </div>
  );
}
